export default function CTASection() {
  return (
    <section id="subscribe" className="py-16 md:py-20">
      <div className="px-6 md:px-14">
        <div className="max-w-xl mx-auto text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            不想错过任何一个
            <br />
            重磅大瓜？
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mb-8">
            订阅每日瓜报，第一时间获取最新爆料，做朋友圈里消息最灵通的吃瓜达人
          </p>
          <form
            data-readdy-form
            action="https://readdy.ai/api/form/d913mus6ci2plld1oi90"
            method="POST"
            encType="application/x-www-form-urlencoded"
            className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          >
            <input
              type="email"
              name="email"
              placeholder="输入你的邮箱"
              required
              className="flex-1 px-5 py-3.5 rounded-full bg-background-100 text-foreground-950 text-sm placeholder:text-foreground-400 border border-background-200/70 focus:outline-none focus:border-primary-300 transition-colors"
            />
            <input
              type="text"
              name="phone_alt"
              tabIndex={-1}
              autoComplete="off"
              aria-hidden="true"
              className="absolute opacity-0 pointer-events-none"
            />
            <button
              type="submit"
              className="inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full bg-primary-500 text-background-50 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              免费订阅
              <i className="ri-arrow-right-line"></i>
            </button>
          </form>
        </div>

        <div className="w-full h-[200px] md:h-[280px] overflow-hidden rounded-3xl bg-background-100">
          <img
            src="https://readdy.ai/api/search-image?query=Wide%20editorial%20banner%20of%20abstract%20warm%20toned%20textured%20paper%20layers%20floating%20horizontally%2C%20cream%20and%20amber%20color%20palette%2C%20minimalist%20clean%20composition%2C%20soft%20shadows%2C%20elegant%20magazine%20aesthetic%2C%20no%20text&width=1600&height=400&seq=cta-banner&orientation=landscape"
            alt="订阅今日大瓜"
            title="订阅每日瓜报 - 今日大瓜"
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
}